<template>
  <!-- Main content -->
  <section class="content">
    
    <!-- Info boxes -->
    <div class="row">
      <!-- <div class="alert alert-success alert-dismissible">
        <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
        <h4><i class="icon fa fa-check"></i> CoPilot is open source!</h4>
        Click on icon to check it out on github. <a href="https://github.com/misterGF/CoPilot" target="_blank"><i class="fa fa-github fa-2x"></i></a>
      </div> 
       -->
      <!-- /.col -->

      <router-link class="pageLink linkRota" to="/pedidos" v-if="possuiDelivery">
        <info-box class="" colorIcon="bg-purple" icon="ion ion-alert">
          <span slot="text">PEDIDOS NOVOS</span>
          <span slot="info">{{novosPedidos}}</span>
        </info-box>
      </router-link>

      <router-link class="pageLink linkRota" to="/pedidos" v-if="possuiDelivery">
        <info-box class="" colorIcon="bg-aqua" icon="ion ion-ios-cart-outline">
            <span slot="text">TODOS OS PEDIDOS</span>
            <span slot="info">{{totalPedidos}}</span>
        </info-box>
      </router-link>

      <router-link class="pageLink linkRota" to="/calendario" v-if="possuiAgendamento">
        <info-box class="" colorIcon="bg-red" icon="ion ion-calendar">
          <span slot="text">AGENDAMENTOS DE HOJE</span>
          <span slot="info">{{agendamentosHoje}}</span>
        </info-box>
      </router-link>

      <router-link class="pageLink linkRota" to="/calendario" v-if="possuiAgendamento">
        <info-box class="" colorIcon="bg-red" icon="ion ion-calendar">
          <span slot="text">TODOS AGENDAMENTOS</span>
          <span slot="info">{{todosAgendamentos}}</span>
        </info-box>
      </router-link>

      <router-link class="pageLink linkRota" to="/solicitacoes" v-if="possuiTurismo">
        <info-box class="" colorIcon="bg-red" icon="ion ion-alert">
          <span slot="text">SOLICITAÇÕES PENDENTES</span>
          <span slot="info">{{solicitacoesPendentes}}</span>
        </info-box>
      </router-link>

      <router-link class="pageLink linkRota" to="/solicitacoes" v-if="possuiTurismo">
        <info-box class="" colorIcon="bg-red" icon="ion ion-ios-cart-outline">
          <span slot="text">TODAS SOLICITAÇÕES</span>
          <span slot="info">{{todasSolicitacoes}}</span>
        </info-box>
      </router-link>

      <!-- <router-link class="pageLink linkRota" to=""> -->
        <info-box class="offset-md-3" colorIcon="bg-green" icon="ion-chatbubbles">
          <span slot="text">Atendimentos</span>
          <span slot="info">{{atendimentos}}</span>
        </info-box>
      <!-- </router-link> -->

      <router-link class="pageLink linkRota" to="/clientes">
        <info-box class="" colorIcon="bg-yellow" icon="ion ion-ios-people-outline">
          <span slot="text">CLIENTES</span>
          <span slot="info">{{clientes}} </span>
        </info-box>
      </router-link>
    </div>

    <!-- GRAPHIC -->
      <box v-if="possuiDelivery">
        <div slot="body" >
            <!--<div class="col-sm-6 col-xs-12">
              <p class="text-center">
                <strong>Web Traffic Overview</strong>
              </p>
              <canvas id="trafficBar" ></canvas>
            </div> -->
            
            <Circle8 class="spinner" v-show="loading"></Circle8>
            
            <div v-show="!loading">
              <div v-if="config.notifica_cliente" class="col-sm-6 col-xs-12 previsaoEntrega">
                <p class="text-center paragrafo">
                  <strong>Previsao de entrega</strong>
                </p>
                <div class="row slider">
                  <vue-slider v-model="tempo_entrega" style="width: 80%"></vue-slider>
                </div>
                <div class="row btnEntrega">
                  <button class="btn btn-primary" v-show="gravar && !gravando" @click="gravarEntrega"><i class="fa fa-check"></i> Gravar</button>
                  <button v-show="gravando" class="btn btn-primary disabled"><i class="fa fa-spinner fa-spin"></i>  Gravando</button>
                </div>
              </div>  
              <hr class="visible-xs-block">

              <div :class="[config.notifica_cliente ? 'col-sm-6 col-xs-12' : 'col-sm-6 col-xs-12 col-sm-offset-3']">
                <p class="text-center" style="font-size:17px">
                  <strong>Ranking de Produtos</strong><br>
                  Comparativo dos três produtos mais vendidos.
                </p>
                <canvas id="languagePie"></canvas>
              </div>
            </div>
        </div>
      </box>

      <box v-if="possuiTurismo">
        <div slot="body" >
            <!--<div class="col-sm-6 col-xs-12">
              <p class="text-center">
                <strong>Web Traffic Overview</strong>
              </p>
              <canvas id="trafficBar" ></canvas>
            </div> -->
            
            <Circle8 class="spinner" v-show="loading"></Circle8>
            
            <!-- <div v-show="!loading">
              <div class="col-sm-6 col-xs-12">
                <p class="text-center" style="font-size:17px">
                  <strong>Pacotes mais vendidos</strong><br>
                  Comparativo dos três pacotes mais vendidos.
                </p>
                <canvas id="rankingPacotes"></canvas>
              </div>
              
              <hr class="visible-xs-block"> -->

              <div class="col-sm-12 col-xs-12">
                <p class="text-center" style="font-size:17px">
                  <strong>Escolhas Preferidas</strong><br>
                  As principais respostas recebidas
                </p>
                <canvas id="tagsPreferidas"></canvas>
              </div>

            </div>
              
        </div>
      </box>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import axios from 'axios'
import InfoBox from './InfoBox'
import Box from './Box'
import {Circle8} from 'vue-loading-spinner'
import vueSlider from 'vue-slider-component'
import modal from './Modal-Large' // importando modal com largura 1000px
import $ from 'jquery'
import firebase from 'firebase'
import moment from 'moment'

export default {
  components: {
    'info-box': InfoBox,
    'box': Box,
    Circle8,
    vueSlider,
    modal,
  },
  data () {
    return {
      generateRandomNumbers (numbers, max, min) {
        var a = []
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max)
        }
        return a
      },
      pedidosImprimir: [],
      modal: false,
      pedidos: [],
      novosPedidos: 0,
      totalPedidos: 0,
      agendamentos: [],
      agendamentosHoje: 0,
      todosAgendamentos: 0,
      solicitacoesPendentes: 0,
      todasSolicitacoes:0,
      atendimentos: 0,
      clientes: 0,
      rankingProdutos: [],
      rankingSoma: [],
      rankingPacotes: [],
      rankingSomaPacotes: [],
      config: [],
      gravar: false,
      tempo_entrega: 0,
      gravando: false,
      visualizou: false,
      loading: true,
      value: 10,
      qtdePedidos: 0,
      total_pedido: 0,
      possuiAgendamento: false,
      possuiDelivery: false,
      possuiAssistencia: false,
      possuiTurismo: false,
      labelTags: [],
      qtdeTags: []
    }
  },
  filters: {
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    tempo_entrega: function() {
      this.gravar = true
    }
  },
  created () {
    this.getAtendimentos()
    this.getClientes()
    this.getConfig()
    this.verificaModulos()
  },
  methods: {
    getPedidos () {
      axios.get(`${this.$store.state.api}pedidos?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.pedidos = response.data
        this.totalPedidos = this.pedidos.length
        this.novosPedidos = this.getNovos()
        // this.faturamento = this.getFaturamento()
        // if(this.novosPedidos > 0 && this.$route.name === 'Pagina Inicial') this.notificar()
        setTimeout(()=> {
          this.getPedidos()     
        },20000)  
      })
    },
    getNovos () {
      var cont = 0
      for (var i = 0; i < this.pedidos.length; i++) {
        if (this.pedidos[i].estado.id === 1) {
          cont++
        }
      }
      return cont
    },
    // getFaturamento () {
    //   var cont = 0;
    //   let data = new Date();
    //   let hoje = data.getDate().toString() + data.getMonth().toString() + data.getFullYear().toString()
    //   for (var i = 0; i < this.pedidos.length; i++) {
    //     let dtPedido = new Date(this.pedidos[i].data_hora);
    //     let pedidoDt = dtPedido.getDate().toString() + dtPedido.getMonth().toString() + dtPedido.getFullYear().toString()
    //     if ( pedidoDt === hoje && (this.pedidos[i].estado.id === 2 || this.pedidos[i].estado.id === 6)) {
    //       cont += this.pedidos[i].preco_total
    //     }
    //   }
    //   return cont
    // },
    getClientes () {
      axios.get(`${this.$store.state.api}clientes?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.clientes = response.data.length
      })
    },
    getConfig() {
      axios.get(`${this.$store.state.api}config?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.config = response.data[0]
        // console.log(this.config)
        this.tempo_entrega = this.config.tempo_entrega
        this.gravar = false
      })
    },
    gravarEntrega(){
      this.gravando = true
      axios.post(this.$store.state.api+'config/tempo-entrega', {
        'tempo_entrega': this.tempo_entrega,
        'empresa': this.$store.state.empresa_fb_id
      }).then((response => {
        if (response.data.success === 'true') {
            this.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Gravado com Sucesso',
              showConfirmButton: false,
              timer: 1500
            })
          } else {
            this.$swal(
              'Ops!',
              'Problemas na gravação. Nenhuma alteração realizada.',
              'error'
            )
            this.getConfig()
          }
          this.gravar=false
          this.gravando=false
      }))
    },
    endLoanding () {
      this.loading = false
    },
    verificaModulos() {
      let modulos = (localStorage.getItem('modulos')).split(',');
      console.log('modulos => ', modulos)
      modulos.forEach(element => {
        switch (element) {
          case 'delivery':
            this.getPedidos()
            this.possuiDelivery = true  
            this.getRanking()
            break;
          case 'assistencia':
            this.getAgendamentos()
            this.possuiAgendamento = true
            this.possuiAssistencia = true
            break;
          case 'agencia_turismo':
            this.getSolicitacoes()
            this.getRankingPacotes()
            this.getTagsPreferidas()
            this.possuiTurismo = true
            break;
          default:
            break;
        }
      });
    },
    getRanking() {
      axios.get(`${this.$store.state.api}ranking?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.rankingProdutos.push(response.data[i].produtos.nome)
          this.rankingSoma.push(response.data[i].soma)
        }
        var pieChartCanvas = document.getElementById('languagePie').getContext('2d')
        var pieConfig = {
          type: 'doughnut',
          data: {
            labels: this.rankingProdutos,
            datasets: [{
              data: this.rankingSoma,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        }

        new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      })
    },
    getRankingPacotes() {
      axios.get(`${this.$store.state.api}pacotes/ranking?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        for (var i = 0; i < response.data.length; i++) {
          if(response.data[i].Pacotes) {
            this.rankingPacotes.push(response.data[i].Pacotes.titulo)
            this.rankingSomaPacotes.push(response.data[i].soma)
          }
        }
        var pieChartCanvas = document.getElementById('rankingPacotes').getContext('2d')
        var pieConfig = {
          type: 'doughnut',
          data: {
            labels: this.rankingPacotes,
            datasets: [{
              data: this.rankingSomaPacotes,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            }
          }
        }

        new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      })
    },
    getTagsPreferidas() {
      axios.get(`${this.$store.state.api}solicitacoes/tags-preferidas?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        for (var i = 0; i < response.data.length; i++) {
          if(response.data[i]) {
            this.labelTags.push(response.data[i].resposta)
            this.qtdeTags.push(response.data[i].count)
          }
        }
        console.log('tags => ', this.labelTags)
        console.log('qtde => ', this.qtdeTags)
        var pieChartCanvas = document.getElementById('tagsPreferidas').getContext('2d')
        var pieConfig = {
          type: 'bar',
          data: {
            labels: this.labelTags,
            datasets: [{
              data: this.qtdeTags,
              backgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD'],
              hoverBackgroundColor: ['#00a65a', '#f39c12', '#00c0ef', '#FF937D', '#9CFFDD']
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: false
            },
              scales: {
                xAxes: [{
                    stacked: true
                }],
                yAxes: [{
                    stacked: true
                }]
              }
          }
        }
        new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
      })
    },
    getSolicitacoes() {
      axios.get(`${this.$store.state.api}solicitacoes?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.todasSolicitacoes = response.data.length;
        let pendentes = response.data.filter(element => { return element.statusid === 2 });
        console.log('pendentes => ', pendentes)
        this.solicitacoesPendentes = pendentes.length
        setTimeout(()=> {
          this.getSolicitacoes()     
        },20000)  
      })
    },
    getAgendamentos () {
      const currentDate = moment(new Date()).format().split('T');
      const data = currentDate[0];
      const hr = currentDate[1].substring(0,5);

      axios.get(`${this.$store.state.api}agenda/next?empresa=${this.$store.state.empresa_fb_id}&data=${data}&hr=${hr}`).then(response => {
        this.agendamentos = response.data
        this.todosAgendamentos = this.agendamentos.length
        this.getAgendamentoHoje()
        setTimeout(()=> {
          this.getAgendamentos()     
        },20000)  
      })
    },
    getAgendamentoHoje () {
      this.agendamentosHoje = 0;
      let currentDate = new Date();
      let year = currentDate.getFullYear(), month = (currentDate.getMonth()+1).toString(), day = currentDate.getDate()
      this.agendamentos.forEach((agendamento) => {
        console.log(`${year}-${month.length == 1 ? '0' + month : month}-${day}`);
        console.log('agendamento => ', agendamento.data)
        if(agendamento.data === `${year}-${month.length == 1 ? '0' + month : month}-${day}`) this.agendamentosHoje++;
      })
    },
    getAtendimentos () {
      var starCountRef = firebase.database().ref('logs/require/' + localStorage.getItem('FB_ID') );
      starCountRef.on('value', (snapshot) => {
        let val = snapshot.val();
        console.log('val ===>', val )
        this.atendimentos = 0;
        Object.keys(val).forEach(element => {
          Object.keys(val[element]).forEach(msg => {
            if(val[element][msg]['newOrder']) this.atendimentos++;
          })
        });
      });
    }
  },
  computed: {
    coPilotNumbers () {
      return this.generateRandomNumbers(12, 1000000, 10000)
    },
    personalNumbers () {
      return this.generateRandomNumbers(12, 1000000, 10000)
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  mounted () {
      
    // })
    this.endLoanding()
  }
}
</script>
<style>

.fullCanvas {
  width: 100%;
}

.linkRota {
  color: black

}
.paragrafo {
  font-size: 17px
}

.previsaoEntrega{
   text-align: center
}
.slider{
    display: flex;
    justify-content: center;
    margin-top: 20%
}
.btnEntrega {
  margin-top: 7%
}
.spinner {
  width: 100%!important;
  height: 100%!important;
}
.info-box-icon{
  background-color: #3C8DBC!important
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?a985f9b0